import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class MapAPI extends ComponentAPI {
    getHeight() {
        return this.state.height;
    }
    setHeight(height) {
        this.setState({ height });
    }
    isVisible() {
        return this.state.visible;
    }
    setVisible(visible) {
        this.setState({ visible });
    }
    isLoading() {
        return this.state.loading ?? false;
    }
    setLoading(loading) {
        this.setState({ loading });
    }
    getProviderUrl() {
        return this.state.providerUrl;
    }
    setProviderUrl(providerUrl) {
        this.setState({ providerUrl });
    }
}
export default MapAPI;
//# sourceMappingURL=map-api.js.map